import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import MetaTags from 'react-meta-tags'

class ContactUs extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        // console.log('metatag')
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>
                    <div className='container'>
                        <div className="row">
                            <Col style={{ paddingLeft: 50 }}>
                                <h2>ติดต่อเรา</h2>
                            </Col>
                        </div>
                    </div>
                    <Row style={{ paddingBottom: 20 }}>
                        <Col xs={12} sm={4} style={{ backgroundColor: '#fafafa' }}>
                            <div>
                                <div className="glyphicon glyphicon-map-marker"></div>  ตลาดยิ่งเจริญ<br /> 651 ถนนพหลโยธิน<br /> แขวงอนุสาวรีย์ เขตบางเขน <br />กรุงเทพมหานคร<br />
                            </div>
                            <div className="glyphicon glyphicon-envelope"></div> marketing@freshmate.co<br />
                            FB: <a href="https://www.facebook.com/songsoddelivery">facebook.com/songsoddelivery</a><br />
                            Line@ <a href="https://line.me/R/ti/p/%40songsod">@songsod</a><br />
                            <div style={{ marginTop: 20, marginBottom: 20 }}></div>
                            <div>
                                <h4>ลูกค้าธุรกิจ</h4>

                                <p>Q : หากต้องการสั่งสินค้าในจำนวนมากสามารถติดต่อได้ที่อย่างไรบ้าง</p>
                                <p>A : ท่านสามารถติดต่อเจ้าหน้าที่ส่งสดได้ที่ Line :@songsod เพื่อสอบถามรายละเอียดเกี่ยวกับลูกค้าธุรกิจ</p>
                            </div>
                        </Col>
                        <Col xs={12} sm={8}>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d992.4714461045124!2d100.60815722232128!3d13.897071628382642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e28299ff1149af%3A0x2929331072f42f58!2sYing+Charoen+Market!5e0!3m2!1sen!2sth!4v1501014647075" width="100%" height="500" style={{ border: 0 }} ></iframe>
                        </Col>
                        <br />
                    </Row>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}

export default ContactUs


// WEBPACK FOOTER //
// ./src/components/contactus.js